import React from "react";
import { Shield } from "lucide-react";
import { t } from "../../i18n/translations";

const FooterNew = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-slate-900 text-white py-12 lg:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-red-600 rounded-lg flex items-center justify-center">
                <Shield size={20} className="text-white" />
              </div>
              <span className="text-lg font-extrabold">
                Emergency<span className="text-red-400">QR</span>
              </span>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">{t("footer.tagline")}</p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Product</h4>
            <div className="space-y-2.5">
              {[
                { label: t("footer.howItWorks"), id: "how-it-works" },
                { label: t("footer.pricing"), id: "benefits" },
                { label: t("footer.corporate"), id: "faq" },
              ].map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollTo(item.id)}
                  className="block text-sm text-slate-400 hover:text-white transition-colors"
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Legal</h4>
            <div className="space-y-2.5">
              <button className="block text-sm text-slate-400 hover:text-white transition-colors">
                {t("footer.privacy")}
              </button>
              <button className="block text-sm text-slate-400 hover:text-white transition-colors">
                {t("footer.terms")}
              </button>
              <span className="block text-sm text-slate-400">{t("footer.dpdpa")}</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Company</h4>
            <div className="space-y-2.5">
              <button className="block text-sm text-slate-400 hover:text-white transition-colors">
                {t("footer.about")}
              </button>
              <span className="block text-sm text-slate-400">{t("footer.madeIn")}</span>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">
            &copy; {new Date().getFullYear()} {t("footer.copyright")}
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-slate-600 bg-slate-800 rounded-full px-3 py-1">{t("footer.dpdpa")}</span>
            <span className="text-xs text-slate-600 bg-slate-800 rounded-full px-3 py-1">{t("footer.madeIn")}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterNew;
